import { Table, Tag } from 'antd';
import { ApiOutlined } from '@ant-design/icons';
import { FormSectionTitle } from '@leedpulse-monorepo/components';
import { ConnectorPlatform, IConnector } from '@leedpulse-monorepo/interfaces';
import dayjs from 'dayjs';

const PLATFORM_LABELS: Record<ConnectorPlatform, string> = {
  googlecalendar: 'Google Calendar',
  apimo: 'Apimo',
  orisha: 'Orisha',
  septeo: 'Septeo',
};

const formatDate = (timestamp: number | null | undefined): string =>
  timestamp ? dayjs(timestamp).format('DD/MM/YYYY HH:mm') : '-';

interface UserConnectorsProps {
  connectors: IConnector[];
}

const UserConnectors: React.FC<UserConnectorsProps> = ({ connectors }) => {
  const columns = [
    {
      title: 'Actif',
      key: 'active',
      render: (record: IConnector) =>
        record.settings?.active ? (
          <Tag color="green">Oui</Tag>
        ) : (
          <Tag color="red">Non</Tag>
        ),
    },
    {
      title: 'Plateforme / type',
      key: 'platform',
      render: (record: IConnector) =>
        PLATFORM_LABELS[record.platform] ?? record.platform,
    },
    {
      title: 'Connecté le',
      key: 'connected_at',
      render: (record: IConnector) => formatDate(record.connected_at),
    },
    {
      title: 'Expire le',
      key: 'expiry_date',
      render: (record: IConnector) => {
        if (record.type !== 'calendar') return '-';
        const expired = record.expiry_date < Date.now();
        return (
          <span style={{ color: expired ? '#cf1322' : undefined }}>
            {formatDate(record.expiry_date)}
            {expired ? ' (expiré)' : ''}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <FormSectionTitle
        title={
          <span>
            <ApiOutlined style={{ marginRight: 6 }} />
            Connecteurs ({connectors.length})
          </span>
        }
      />
      <div className="users-card-companies-container">
        {connectors.length > 0 ? (
          <Table
            pagination={false}
            columns={columns}
            rowKey={(record) => `${record.type}-${record.platform}-${record.company_id ?? 'personal'}`}
            dataSource={connectors}
            size="small"
          />
        ) : (
          <p style={{ textAlign: 'center', fontSize: '14px', color: '#888' }}>
            Aucun connecteur
          </p>
        )}
      </div>
    </>
  );
};

export default UserConnectors;
